import { useEffect } from "react";
import { supabase } from "./lib/supabase";

const clean=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim();
type WeldAssignment={id:string;joint_id:string|null;weld_number:string;drawing_number:string|null;part_or_assembly:string|null;process:string|null;weld_type:string|null;position:string|null;thickness_mm:number|null;heat_number:string|null;wpds_number:string|null;welder_id:string|null;welder_name:string|null;inspection_status:string|null;ndt_methods:string[]|null;ndt_status:string|null;ncr_status:string|null;status:string;weld_date:string|null;notes:string|null};

async function currentProjectId(){
  const head=document.querySelector<HTMLElement>(".project-detail-head");
  if(!head)return null;
  const projectNumber=clean(head.querySelector(".eyebrow")?.textContent);
  const projectName=clean(head.querySelector("h1")?.textContent);
  let query=supabase.from("projects").select("id").limit(1);
  if(projectNumber&&projectNumber!=="PROJECT")query=query.eq("project_number",projectNumber);
  else if(projectName)query=query.eq("name",projectName);
  else return null;
  const {data}=await query.maybeSingle();
  return data?.id as string|undefined;
}

function openWeldRegister(openAdd=false){
  const picker=document.querySelector<HTMLSelectElement>("#project-section");
  if(!picker)return;
  picker.value="weld_register";
  picker.dispatchEvent(new Event("change",{bubbles:true}));
  if(openAdd){
    window.setTimeout(()=>{
      const add=[...document.querySelectorAll<HTMLButtonElement>(".weld-register button")].find(button=>clean(button.textContent).toLowerCase().includes("add weld"));
      add?.click();
    },180);
  }
}

function ensureAssignmentStyles(){
  if(document.getElementById("arcvault-assignment-sync-style"))return;
  const style=document.createElement("style");
  style.id="arcvault-assignment-sync-style";
  style.textContent=`
    .arcvault-weld-assignment-wrap{padding:22px 28px 30px;border-top:1px solid #d8e3ec}
    .arcvault-assignment-note{display:flex;justify-content:space-between;gap:18px;align-items:center;margin-bottom:18px;padding:14px 16px;border:1px solid #d6e2ec;border-radius:12px;background:#f6f9fc;color:#55708a;font-size:14px}
    .arcvault-assignment-note b{color:#113552}
    .arcvault-assignment-list{display:grid;gap:14px}
    .arcvault-assignment-card{border:1px solid #cfdeea;border-radius:14px;background:#fff;overflow:hidden}
    .arcvault-assignment-head{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 18px;background:#f7fafc;border-bottom:1px solid #dbe5ed}
    .arcvault-assignment-person{display:flex;align-items:center;gap:12px;min-width:0}
    .arcvault-assignment-avatar{display:grid;place-items:center;width:42px;height:42px;border-radius:50%;background:#dceefd;color:#124f7c;font-weight:900;flex:0 0 auto}
    .arcvault-assignment-person b{display:block;font-size:18px;color:#102f49}
    .arcvault-assignment-person small{display:block;color:#6a8297;margin-top:2px}
    .arcvault-assignment-count{padding:8px 12px;border:1px solid #cfe0ed;border-radius:999px;color:#245c82;font-weight:800;white-space:nowrap}
    .arcvault-assignment-welds{display:grid}
    .arcvault-assignment-weld{display:grid;grid-template-columns:minmax(150px,1.1fr) minmax(120px,.8fr) minmax(220px,1.4fr) auto;gap:18px;align-items:center;padding:14px 18px;border-top:1px solid #edf2f6;cursor:pointer;transition:background .15s ease}
    .arcvault-assignment-weld:first-child{border-top:0}\n    .arcvault-assignment-weld:hover{background:#f6fbff}\n    .arcvault-assignment-weld:focus{outline:2px solid #5aa7df;outline-offset:-2px}
    .arcvault-assignment-weld strong{color:#102f49}
    .arcvault-assignment-weld span,.arcvault-assignment-weld small{display:block;color:#617b91}
    .arcvault-assignment-weld .status{justify-self:end}
    .arcvault-assignment-empty{padding:54px 24px;text-align:center;color:#6a8297}
    .arcvault-assignment-empty h3{margin:0 0 8px;color:#102f49;font-size:24px}
    .arcvault-weld-view-bg{position:fixed;inset:0;z-index:1000;display:grid;place-items:center;padding:20px;background:#061728a8}
    .arcvault-weld-view{position:relative;width:min(900px,100%);max-height:90vh;overflow:auto;padding:28px;border-radius:12px;background:#fff;box-shadow:0 24px 70px #06172855}
    .arcvault-weld-view-close{position:absolute;right:16px;top:12px;border:0;background:transparent;color:#71808d;font-size:26px}
    .arcvault-weld-view h2{margin:5px 0 20px;color:#102f49}
    .arcvault-weld-view-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:10px}
    .arcvault-weld-view-fact{min-width:0;padding:12px 14px;border:1px solid #dce4e9;border-radius:8px;background:#f8fafc}
    .arcvault-weld-view-fact small{display:block;margin-bottom:6px;color:#718391;font-size:8px;font-weight:900;letter-spacing:.08em}
    .arcvault-weld-view-fact b{display:block;color:#17334a;font-size:11px;overflow-wrap:anywhere}
    .arcvault-weld-view-notes{margin-top:12px;padding:14px;border:1px solid #dce4e9;border-radius:8px}
    .arcvault-weld-view-actions{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:8px;margin-top:20px}
    .arcvault-weld-view-actions button{border:1px solid #ccd6de;border-radius:5px;background:#fff;padding:10px 15px;font-weight:800}
    .arcvault-weld-view-actions .edit{border-color:#176bd0;background:#176bd0;color:#fff}
    .arcvault-weld-view-actions .delete{margin-right:auto;border-color:#d84e4e;background:#fff5f5;color:#b52d2d}
    @media(max-width:850px){.arcvault-assignment-weld{grid-template-columns:1fr 1fr}.arcvault-assignment-weld .status{justify-self:start}.arcvault-assignment-note{align-items:flex-start;flex-direction:column}}
  `;
  document.head.appendChild(style);
}

function initials(name:string){return name.split(/\s+/).filter(Boolean).slice(0,2).map(x=>x[0]?.toUpperCase()||"").join("")||"W"}
function statusClass(status:string){return status==="accepted"||status==="ready"?"active":status==="hold"||status==="rejected"?"expired":"expiring"}

function display(value:string|null|undefined,fallback="Not entered"){return clean(value)||fallback}
function pretty(value:string|null|undefined){return display(value,"Not entered").replace(/_/g," ").toUpperCase()}

function openAssignmentWeld(weld:WeldAssignment,welds:WeldAssignment[]){
  document.querySelector(".arcvault-weld-view-bg")?.remove();
  const bg=document.createElement("div");bg.className="arcvault-weld-view-bg";
  const modal=document.createElement("div");modal.className="arcvault-weld-view";modal.setAttribute("role","dialog");modal.setAttribute("aria-modal","true");
  const close=document.createElement("button");close.type="button";close.className="arcvault-weld-view-close";close.textContent="×";close.setAttribute("aria-label","Close");
  const heading=document.createElement("div");heading.innerHTML=`<p class="eyebrow">WELD RECORD</p><h2></h2>`;heading.querySelector("h2")!.textContent=display(weld.joint_id||weld.weld_number,"Weld");
  const grid=document.createElement("div");grid.className="arcvault-weld-view-grid";
  const facts:[string,string][]=[
    ["Drawing",display(weld.drawing_number,"Not linked")],
    ["Weld / Joint ID",display(weld.joint_id||weld.weld_number,"Weld")],
    ["Part or assembly",display(weld.part_or_assembly)],
    ["Process",display(weld.process)],
    ["Weld type",display(weld.weld_type)],
    ["Position",display(weld.position)],
    ["Thickness",weld.thickness_mm!=null?`${weld.thickness_mm} mm`:"Not entered"],
    ["Material heat / MTR",display(weld.heat_number,"Not linked")],
    ["Applicable WPDS",display(weld.wpds_number,"Not linked")],
    ["Assigned welder",display(weld.welder_name,"Not assigned")],
    ["Weld date",display(weld.weld_date)],
    ["In-house inspection",pretty(weld.inspection_status)],
    ["NDT method",weld.ndt_methods?.length?weld.ndt_methods.join(", "):"Not required"],
    ["NDT status",pretty(weld.ndt_status)],
    ["NCR",pretty(weld.ncr_status)],
    ["Final status",pretty(weld.status)]
  ];
  facts.forEach(([label,value])=>{const fact=document.createElement("div");fact.className="arcvault-weld-view-fact";const small=document.createElement("small");small.textContent=label.toUpperCase();const strong=document.createElement("b");strong.textContent=value;fact.append(small,strong);grid.appendChild(fact)});
  modal.append(close,heading,grid);
  if(clean(weld.notes)){const notes=document.createElement("div");notes.className="arcvault-weld-view-notes";const label=document.createElement("small");label.textContent="NOTES";const copy=document.createElement("p");copy.textContent=weld.notes;notes.append(label,copy);modal.appendChild(notes)}
  const actions=document.createElement("div");actions.className="arcvault-weld-view-actions";
  const remove=document.createElement("button");remove.type="button";remove.className="delete";remove.textContent="Delete weld";
  const cancel=document.createElement("button");cancel.type="button";cancel.textContent="Close";
  const edit=document.createElement("button");edit.type="button";edit.className="edit";edit.textContent="Edit weld";
  const dismiss=()=>bg.remove();close.addEventListener("click",dismiss);cancel.addEventListener("click",dismiss);bg.addEventListener("mousedown",event=>{if(event.target===bg)dismiss()});
  edit.addEventListener("click",()=>{window.sessionStorage.setItem("arcvault:open-weld-id",weld.id);dismiss();openWeldRegister(false)});
  remove.addEventListener("click",async()=>{
    if(!window.confirm(`Are you sure you want to delete weld ${display(weld.joint_id||weld.weld_number,"Weld")}? This cannot be undone.`))return;
    const {error}=await supabase.from("project_weld_register").delete().eq("id",weld.id);
    if(error){window.alert(error.message);return}
    dismiss();renderAssignments(welds.filter(item=>item.id!==weld.id));
  });
  actions.append(remove,cancel,edit);modal.appendChild(actions);bg.appendChild(modal);document.body.appendChild(bg);close.focus();
}

function renderAssignments(welds:WeldAssignment[]){
  const panel=[...document.querySelectorAll<HTMLElement>("section.table-card")].find(section=>clean(section.querySelector("h2")?.textContent)==="Project assignments");
  if(!panel)return;
  ensureAssignmentStyles();
  const assigned=welds.filter(w=>w.welder_id&&clean(w.welder_name));
  const signature=assigned.map(w=>`${w.id}:${w.welder_id}:${w.status}:${w.wpds_number||""}`).join("|");
  if(panel.dataset.arcvaultAssignmentSignature===signature)return;
  panel.dataset.arcvaultAssignmentSignature=signature;

  const title=panel.querySelector<HTMLElement>(".section-title");
  if(title){
    const right=[...title.querySelectorAll<HTMLElement>("small,p,span")].find(x=>clean(x.textContent).toLowerCase().includes("eligibility"));
    if(right)right.textContent="Live from Weld Register";
  }
  [...panel.children].forEach(child=>{if(child!==title)child.remove()});

  const wrap=document.createElement("div");
  wrap.className="arcvault-weld-assignment-wrap";
  const note=document.createElement("div");
  note.className="arcvault-assignment-note";
  note.innerHTML='<span><b>Assignments are controlled from the Weld Register.</b> Assign or change a qualified welder on the weld record and this page updates automatically.</span>';
  const open=document.createElement("button");
  open.type="button";open.textContent="Open Weld Register";open.className="primary";open.addEventListener("click",()=>openWeldRegister(false));
  note.appendChild(open);wrap.appendChild(note);

  if(!assigned.length){
    const empty=document.createElement("div");empty.className="arcvault-assignment-empty";
    empty.innerHTML="<h3>No welders assigned</h3><p>Assign a qualified welder to a weld in the Weld Register. The assignment will appear here automatically.</p>";
    wrap.appendChild(empty);panel.appendChild(wrap);return;
  }

  const groups=new Map<string,{name:string;welds:WeldAssignment[]}>();
  assigned.forEach(w=>{const key=w.welder_id!;const group=groups.get(key)||{name:w.welder_name!,welds:[]};group.welds.push(w);groups.set(key,group)});
  const list=document.createElement("div");list.className="arcvault-assignment-list";
  groups.forEach(group=>{
    const card=document.createElement("article");card.className="arcvault-assignment-card";
    const head=document.createElement("div");head.className="arcvault-assignment-head";
    head.innerHTML=`<div class="arcvault-assignment-person"><span class="arcvault-assignment-avatar">${initials(group.name)}</span><div><b>${group.name}</b><small>Qualified welder assigned in Weld Register</small></div></div><span class="arcvault-assignment-count">${group.welds.length} weld${group.welds.length===1?"":"s"}</span>`;
    card.appendChild(head);
    const rows=document.createElement("div");rows.className="arcvault-assignment-welds";
    group.welds.forEach(w=>{
      const row=document.createElement("div");row.className="arcvault-assignment-weld";
      const weldId=clean(w.joint_id)||clean(w.weld_number)||"Weld";
      row.innerHTML=`<div><strong>${weldId}</strong><small>${w.drawing_number||"No drawing linked"}</small></div><div><strong>${w.process||"Process pending"}</strong><small>${w.position||"Position pending"}</small></div><div><strong>${w.wpds_number||"No WPDS linked"}</strong><small>${w.weld_date||"Weld date not entered"}</small></div><span class="status ${statusClass(w.status)}">● ${clean(w.status).replace(/_/g," ").toUpperCase()}</span>`;
      row.tabIndex=0;row.setAttribute("role","button");row.setAttribute("aria-label",`Open weld ${weldId}`);
      const openWeld=()=>openAssignmentWeld(w,welds);
      row.addEventListener("click",openWeld);
      row.addEventListener("keydown",event=>{if(event.key==="Enter"||event.key===" "){event.preventDefault();openWeld()}});
      rows.appendChild(row);
    });
    card.appendChild(rows);list.appendChild(card);
  });
  wrap.appendChild(list);panel.appendChild(wrap);
}

export default function ProjectWeldRegisterConsolidation(){
  useEffect(()=>{
    let stopped=false;
    let timer:number|undefined;

    const apply=async()=>{
      if(stopped)return;
      const picker=document.querySelector<HTMLSelectElement>("#project-section");
      if(!picker)return;

      const requirementOption=[...picker.options].find(option=>option.value==="requirements"||clean(option.textContent)==="Weld Requirements");
      requirementOption?.remove();
      if(picker.value==="requirements")openWeldRegister(false);

      const head=document.querySelector<HTMLElement>(".project-detail-head");
      const addRequirement=[...(head?.querySelectorAll<HTMLButtonElement>("button")||[])].find(button=>clean(button.textContent).toLowerCase().includes("add weld requirement"));
      if(addRequirement&&!addRequirement.dataset.arcvaultWeldAction){
        addRequirement.dataset.arcvaultWeldAction="true";
        addRequirement.textContent="＋ Add Weld";
        addRequirement.addEventListener("click",event=>{
          event.preventDefault();event.stopImmediatePropagation();openWeldRegister(true);
        },true);
      }

      const projectId=await currentProjectId();
      if(projectId){
        const {data:weldRows,error:weldError}=await supabase.from("project_weld_register").select("id,joint_id,weld_number,drawing_number,part_or_assembly,process,weld_type,position,thickness_mm,heat_number,wpds_number,welder_id,welder_name,inspection_status,ndt_methods,ndt_status,ncr_status,status,weld_date,notes").eq("project_id",projectId).order("weld_number");
        if(!weldError){
          const welds=(weldRows||[]) as WeldAssignment[];
          const summary=document.querySelector<HTMLElement>(".project-summary-bar");
          const cells=summary?[...summary.querySelectorAll<HTMLElement>(":scope > span")]:[];
          const weldCell=cells.find(cell=>["REQUIREMENTS","WELDS"].includes(clean(cell.querySelector("small")?.textContent)));
          if(weldCell){const label=weldCell.querySelector("small");if(label)label.textContent="WELDS";const value=weldCell.querySelector("b");if(value)value.textContent=String(welds.length)}
          const assignedCell=cells.find(cell=>clean(cell.querySelector("small")?.textContent)==="ASSIGNED WELDERS");
          if(assignedCell){const value=assignedCell.querySelector("b");if(value)value.textContent=String(new Set(welds.filter(w=>w.welder_id).map(w=>w.welder_id)).size)}
          if(picker.value==="assignments")renderAssignments(welds);
        }
      }

      [...document.querySelectorAll<HTMLLabelElement>(".modal label")].forEach(label=>{
        const text=clean(label.childNodes[0]?.textContent||label.textContent).toLowerCase();
        if(text.startsWith("weld requirement")||text.startsWith("requirement"))label.style.display="none";
      });

      [...document.querySelectorAll<HTMLElement>(".content *")].forEach(node=>{
        if(node.children.length)return;
        const text=clean(node.textContent);
        if(text==="WELD REQUIREMENTS")node.textContent="WELDS";
        else if(text.includes("weld requirements ready"))node.textContent=text.replace(/weld requirements ready/i,"welds ready");
      });
    };

    const schedule=()=>{window.clearTimeout(timer);timer=window.setTimeout(()=>void apply(),100)};
    const observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true});
    document.addEventListener("change",schedule,true);
    schedule();
    return()=>{stopped=true;window.clearTimeout(timer);observer.disconnect();document.removeEventListener("change",schedule,true)};
  },[]);
  return null;
}
